// localStorage 기반 draft (임시저장) 헬퍼.
//
// - 사용자 브라우저에만 저장 (서버 안 감)
// - 만료 시간 (기본 24시간) 지나면 자동 무효화
// - JSON 직렬화: dayjs 객체는 toJSON()으로 ISO 문자열이 되므로,
//   복원 시 호출 측에서 특정 필드를 dayjs로 다시 변환해야 함.

const DEFAULT_MAX_AGE_HOURS = 24;

export function saveDraft(key, data) {
  if (!key) return;
  try {
    const payload = JSON.stringify({
      data,
      saved_at: Date.now(),
    });
    localStorage.setItem(key, payload);
  } catch (e) {
    // localStorage 사용 불가 (private mode 등) → 조용히 실패
    // 임시저장은 부가 기능이라 실패해도 본 기능 영향 없음
  }
}

// 반환: { data, saved_at } 또는 null (없거나 만료 또는 에러)
export function loadDraft(key, maxAgeHours = DEFAULT_MAX_AGE_HOURS) {
  if (!key) return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const { data, saved_at } = parsed;
    if (!saved_at) return null;
    const ageMs = Date.now() - saved_at;
    if (ageMs > maxAgeHours * 60 * 60 * 1000) {
      localStorage.removeItem(key);
      return null;
    }
    return { data, saved_at };
  } catch (e) {
    // 파싱 실패 등은 무시. 손상된 데이터는 제거.
    try {
      localStorage.removeItem(key);
    } catch (e2) {}
    return null;
  }
}

export function clearDraft(key) {
  if (!key) return;
  try {
    localStorage.removeItem(key);
  } catch (e) {}
}

// 사람이 보기 좋은 경과 시간 ("3분 전", "약 2시간 전" 등)
export function formatRelativeTime(timestampMs) {
  const diffMs = Date.now() - timestampMs;
  const min = Math.floor(diffMs / 60000);
  if (min < 1) return "방금";
  if (min < 60) return `${min}분 전`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `약 ${hr}시간 전`;
  const day = Math.floor(hr / 24);
  return `${day}일 전`;
}
